import { Option } from '@common-fe/common-fe';

import { storeCreator } from '@/utils/store/store.utils';

interface State {
  duplicationItem: Option | null;

  setDuplicationItem: (value: Option | null) => void;
}

const useFilesStore = storeCreator<State>((set) => ({
  duplicationItem: null,

  setDuplicationItem: (value) => set(() => ({
    duplicationItem: value 
  })),
}));

export default useFilesStore;
